import { Flex, Spinner } from '@chakra-ui/react';
import { ReactElement } from 'react';

export const Loading = (): ReactElement => {
  return (
    <Flex direction='column' alignItems='center' h='full' padding={4} paddingTop={4}>
      <Spinner />
    </Flex>
  );
};
